export const LIST_VENDORS_REQUEST = 'LIST_VENDORS_REQUEST'
export const LIST_VENDORS_SUCCESS = 'LIST_VENDORS_SUCCESS'
export const LIST_VENDORS_FAIL = 'LIST_VENDORS_FAIL'
export const LIST_VENDORS_RESET = 'LIST_VENDORS_RESET'



export const VENDORS_DELETE_REQUEST = 'VENDORS_DELETE_REQUEST'
export const VENDORS_DELETE_SUCCESS = 'VENDORS_DELETE_SUCCESS'
export const VENDORS_DELETE_FAIL = 'VENDORS_DELETE_FAIL'